import React, { useState } from "react";
import Icon from "./Icon";

// "Not sure what to write?" with one gentle idea, and a button for another.
export default function PromptIdea({ prompts }: { prompts: string[] }) {
  const [i, setI] = useState(() => Math.floor(Math.random() * prompts.length));
  return (
    <p className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-ink-soft" aria-live="polite">
      <Icon name="edit" size={14} />
      <span>
        Not sure what to write? <em>{prompts[i]}</em>
      </span>
      <button
        type="button"
        className="chip"
        onClick={() => setI((n) => (n + 1 + Math.floor(Math.random() * (prompts.length - 1))) % prompts.length)}
      >
        another idea
      </button>
    </p>
  );
}
